import React from 'react';
import classNames from 'classnames';
import { TextInput } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import styles from '../RegionNoteForm.css';

type RegionNoteFormTitleProps = {
  title: string;
  setTitle: (string) => void;
  showTitleErrorMessage: boolean;
};

export const RegionNoteFormTitle = ({
  title,
  setTitle,
  showTitleErrorMessage
}: RegionNoteFormTitleProps) => (
  <>
    <TextInput
      className={classNames(styles.frrInput, {
        [styles.frrInputErrorBorder]: showTitleErrorMessage
      })}
      data-test-id="region-note-form-field-title"
      label={getMessage('scouting.form.title')}
      labelClassName={classNames({
        [styles.frrInputError]: showTitleErrorMessage
      })}
      maxLength="50"
      name="title"
      onChange={({ target: { value } }) => setTitle(value)}
      value={title}
    />
    {showTitleErrorMessage && (
      <>
        <div className={styles.frrInputError}>{getMessage('scouting.form.addTitle.error')}</div>
        <br />
      </>
    )}
  </>
);
